module.exports = __webpack_public_path__ + "static/playstore-e76386f62f095bb51bb8bd22d8376857.png";